import { styled as t } from "styled-components";
import { CaptionHeavy as e } from "../../styles/typography/index.js";
import { Theme as o } from "../../styles/themes/index.js";
const r = t.div`
  position: relative;
`, l = t.div`
  max-height: 0;
  overflow: hidden;
  position: relative;

  &[aria-hidden='false'] {
    max-height: 100%;
  }
`, s = t.button`
  ${e};
  display: flex;
  justify-content: center;
  align-items: center;
  color: rgb(${o.colors.Alpha});
  margin-left: auto;
  background: transparent;
  margin-right: auto;
  text-decoration: underline;

  &[aria-hidden='false'] {
    margin-top: 10px;
  }
`;
export {
  s as CollapseButton,
  r as CollapseContainer,
  l as CollpaseContent
};
